import { apiClient } from '@app/api';
import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { Client } from '@app/core/types/client';
import { User } from '@mi-front/core';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, ListItemSecondaryAction, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { ImpersonationUserListItem } from '../components/ImpersonationUserListItem';
import { useImpersonation } from '../hooks/useImpersonationStore';
import { impersonationMessages } from '../impersonation-messages';
import { clearTabAuthAs } from './tab-auth-as';

type TabDeepLinkUserClusterProps = {
  user: User & { client: Client };
};

/**
 * Shows the user active in this tab via session-scoped auth_as (deep link or OpenInNew).
 * Clearing drops the session override and falls back to the saved impersonation user.
 */
export function TabDeepLinkUserCluster({ user }: TabDeepLinkUserClusterProps) {
  const { $t } = useIntl();
  const { impersonatedUser } = useImpersonation();

  /** Removes tab-scoped auth_as and reloads so API headers and UI stay in sync. */
  function handleClear() {
    clearTabAuthAs();
    apiClient.setAuthAs(impersonatedUser?.id ?? null);
    window.location.reload();
  }

  return (
    <ContentCluster message={impersonationMessages.tabDeepLinkUserTitle}>
      <ImpersonationUserListItem user={user} sx={{ px: 0, pr: 6 }}>
        <ListItemSecondaryAction>
          <Tooltip title={$t(impersonationMessages.clearTabAuthAsAriaLabel)}>
            <IconButton
              edge="end"
              aria-label={$t(impersonationMessages.clearTabAuthAsAriaLabel)}
              onClick={handleClear}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </ListItemSecondaryAction>
      </ImpersonationUserListItem>
    </ContentCluster>
  );
}
